import { Checkboxes } from 'nhsuk-react-components';

const AdditionalFilters = ({ submissionSummary }) => {
    const additionalQuestions = submissionSummary.filter(
        question => question.type === 'status' || question.type === 'actions'
    );

    return (
        <form>
            {additionalQuestions.map(question => (
                <Checkboxes
                    key={question.id}
                    id={question.id}
                    name={question.id}
                    label={question.display || question.id}
                >
                    {Array.isArray(question.options) && question.options.length > 0 ? (
                        question.options.map((option, index) => (
                            <Checkboxes.Box
                                key={index}
                                value={option.key}
                                name={question.id}
                                onChange={() => {}}
                            >
                                {option.value}
                            </Checkboxes.Box>
                        ))
                    ) : (
                        <p key={`${question.id}-no-options`}>No options available</p>
                    )}
                </Checkboxes>
            ))}
        </form>
    );
};

export default AdditionalFilters;
